/* eslint-disable */
import { StepMock } from '../../interfaces/mock.interface';

const CLICK_COLLECT = {
    resultCount: 5,
    items: [
        {
            self: {
                href: '/consultation-boutique?codeEnseigne=993&codePointVente=0518',
            },
            codeEnseigne: '993',
            codePointVente: '0518',
            distanceLocalisation: 888,
            libelleEnseigneCommerciale: 'BOUYGUES TELECOM',
            nom: 'PARIS SECRETAN',
            adresse: {
                adresseLigne1: '4 AVENUE SECRETAN',
                ville: 'PARIS',
                codePostal: '75019',
                pays: 'FR',
                localisation: {
                    latitude: 48.88212,
                    longitude: 2.37077,
                },
            },
            horairesOuvertureDuJour: {
                plagesHoraire: [
                    {
                        debut: '10:30',
                        fin: '19:00',
                    },
                ],
            },
            activitesBoutique: {
                cncActif: true,
                eresaActif: true,
                webActif: true,
                maxCnC: 65,
                maxEResa: 0,
                maxCnC_sav: 50,
                maxCnC_vente: 15,
            },
            contact: {
                telephone1: '986010358',
                telephone2: '',
                fax: '142002523',
                email: 'ParisSecretan-0557@rcbt.fr',
                employeTelephone1: '0650609452',
                employeTelephone2: '0646031909',
                employeTelephone3: '0781757763',
            },
            responsable: {
                nom: '',
                telephone: '',
            },
            horairesOuvertureHebdomadaire: [
                {
                    noJour: 1,
                    plagesHoraire: [
                        {
                            debut: '10:30',
                            fin: '19:00',
                        },
                    ],
                },
                {
                    noJour: 2,
                    plagesHoraire: [
                        {
                            debut: '10:30',
                            fin: '19:00',
                        },
                    ],
                },
                {
                    noJour: 3,
                    plagesHoraire: [
                        {
                            debut: '10:30',
                            fin: '19:00',
                        },
                    ],
                },
                {
                    noJour: 4,
                    plagesHoraire: [
                        {
                            debut: '10:30',
                            fin: '19:00',
                        },
                    ],
                },
                {
                    noJour: 5,
                    plagesHoraire: [
                        {
                            debut: '10:30',
                            fin: '19:00',
                        },
                    ],
                },
                {
                    noJour: 6,
                    plagesHoraire: [
                        {
                            debut: '10:30',
                            fin: '19:00',
                        },
                    ],
                },
            ],
            entiteJuridique: {
                typeEntiteReseauDistribution: 'CS',
                siren: '423032598',
            },
            typeEntiteReseauDistribution: 'CS',
            estPetitBackOffice: false,
            proprietesERD: [
                {
                    id: '1',
                    nom: 'petit_back_office',
                    type: 'BOOLEEN',
                    valeurBool: false,
                },
            ],
            seuilsProduits: [
                {
                    gencode: '8806090306419',
                    seuilCnC: 3,
                    seuilEResa: 0,
                },
            ],
            gencodes: ['8806090306419'],
        },
        {
            self: {
                href: '/consultation-boutique?codeEnseigne=993&codePointVente=0430',
            },
            codeEnseigne: '993',
            codePointVente: '0430',
            distanceLocalisation: 940,
            libelleEnseigneCommerciale: 'BOUYGUES TELECOM',
            nom: 'PARIS REPUBLIQUE',
            adresse: {
                adresseLigne1: '16 PLACE DE LA REPUBLIQUE',
                ville: 'PARIS',
                codePostal: '75010',
                pays: 'FR',
                localisation: {
                    latitude: 48.86818,
                    longitude: 2.3625,
                },
            },
            horairesOuvertureDuJour: {
                plagesHoraire: [
                    {
                        debut: '10:00',
                        fin: '19:30',
                    },
                ],
            },
            activitesBoutique: {
                cncActif: true,
                eresaActif: true,
                webActif: true,
                maxCnC: 65,
                maxEResa: 0,
                maxCnC_sav: 50,
                maxCnC_vente: 15,
            },
            contact: {
                telephone1: '986010345',
                telephone2: '',
                fax: '142391116',
                email: 'ParisRepublique-0921@rcbt.fr',
                employeTelephone1: '0650101047',
                employeTelephone2: '0761671200',
                employeTelephone3: '0652047809',
            },
            responsable: {
                nom: '',
                telephone: '',
            },
            horairesOuvertureHebdomadaire: [
                {
                    noJour: 1,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '19:30',
                        },
                    ],
                },
                {
                    noJour: 2,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '19:30',
                        },
                    ],
                },
                {
                    noJour: 3,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '19:30',
                        },
                    ],
                },
                {
                    noJour: 4,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '19:30',
                        },
                    ],
                },
                {
                    noJour: 5,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '19:30',
                        },
                    ],
                },
                {
                    noJour: 6,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '19:30',
                        },
                    ],
                },
            ],
            entiteJuridique: {
                typeEntiteReseauDistribution: 'CS',
                siren: '423032598',
            },
            typeEntiteReseauDistribution: 'CS',
            estPetitBackOffice: false,
            proprietesERD: [
                {
                    id: '1',
                    nom: 'petit_back_office',
                    type: 'BOOLEEN',
                    valeurBool: false,
                },
            ],
            seuilsProduits: [
                {
                    gencode: '8806090306419',
                    seuilCnC: 3,
                    seuilEResa: 0,
                },
            ],
            gencodes: ['8806090306419'],
        },
        {
            self: {
                href: '/consultation-boutique?codeEnseigne=499&codePointVente=2012',
            },
            codeEnseigne: '499',
            codePointVente: '2012',
            distanceLocalisation: 1142,
            libelleEnseigneCommerciale: 'BOUYGUES TELECOM',
            nom: 'PARIS BELLEVILLE',
            adresse: {
                adresseLigne1: '113 RUE DE BELLEVILLE',
                ville: 'PARIS',
                codePostal: '75019',
                pays: 'FR',
                localisation: {
                    latitude: 48.87477,
                    longitude: 2.38718,
                },
            },
            horairesOuvertureDuJour: {
                plagesHoraire: [
                    {
                        debut: '10:00',
                        fin: '19:00',
                    },
                ],
            },
            activitesBoutique: {
                cncActif: true,
                eresaActif: true,
                webActif: true,
                maxCnC: 65,
                maxEResa: 0,
                maxCnC_sav: 50,
                maxCnC_vente: 15,
            },
            contact: {
                telephone1: '986010357',
                telephone2: '',
                fax: '153198770',
                email: 'CA-ParisBelleville-0236@rcbt.fr',
                employeTelephone1: '0616920499',
                employeTelephone2: '0755703730',
                employeTelephone3: '',
            },
            responsable: {
                nom: '',
                telephone: '',
            },
            horairesOuvertureHebdomadaire: [
                {
                    noJour: 1,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '19:00',
                        },
                    ],
                },
                {
                    noJour: 2,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '19:00',
                        },
                    ],
                },
                {
                    noJour: 3,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '19:00',
                        },
                    ],
                },
                {
                    noJour: 4,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '19:00',
                        },
                    ],
                },
                {
                    noJour: 5,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '19:00',
                        },
                    ],
                },
                {
                    noJour: 6,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '19:00',
                        },
                    ],
                },
            ],
            entiteJuridique: {
                typeEntiteReseauDistribution: 'CA',
                siren: '392031894',
            },
            typeEntiteReseauDistribution: 'CA',
            estPetitBackOffice: false,
            proprietesERD: [
                {
                    id: '1',
                    nom: 'petit_back_office',
                    type: 'BOOLEEN',
                    valeurBool: false,
                },
            ],
            seuilsProduits: [
                {
                    gencode: '8806090306419',
                    seuilCnC: 3,
                    seuilEResa: 0,
                },
            ],
            gencodes: ['8806090306419'],
        },
        {
            self: {
                href: '/consultation-boutique?codeEnseigne=400&codePointVente=2128',
            },
            codeEnseigne: '400',
            codePointVente: '2128',
            distanceLocalisation: 2098,
            libelleEnseigneCommerciale: 'BOUYGUES TELECOM',
            nom: 'PARIS PYRENEES',
            adresse: {
                adresseLigne1: '253 RUE DES PYRENEES',
                ville: 'PARIS',
                codePostal: '75020',
                pays: 'FR',
                localisation: {
                    latitude: 48.866,
                    longitude: 2.39747,
                },
            },
            horairesOuvertureDuJour: {
                plagesHoraire: [
                    {
                        debut: '11:30',
                        fin: '13:30',
                    },
                    {
                        debut: '14:30',
                        fin: '19:15',
                    },
                ],
            },
            activitesBoutique: {
                cncActif: true,
                eresaActif: true,
                webActif: true,
                maxCnC: 65,
                maxEResa: 0,
                maxCnC_sav: 50,
                maxCnC_vente: 15,
            },
            contact: {
                telephone1: '986010359',
                telephone2: '',
                fax: '158535520',
                email: 'ParisPyrenees-01AH@rcbt.fr',
                employeTelephone1: '0761031284',
                employeTelephone2: '0662080915',
                employeTelephone3: '0652117957',
            },
            responsable: {
                nom: '',
                telephone: '',
            },
            horairesOuvertureHebdomadaire: [
                {
                    noJour: 1,
                    plagesHoraire: [
                        {
                            debut: '11:30',
                            fin: '13:30',
                        },
                        {
                            debut: '14:30',
                            fin: '19:15',
                        },
                    ],
                },
                {
                    noJour: 2,
                    plagesHoraire: [
                        {
                            debut: '10:30',
                            fin: '13:30',
                        },
                        {
                            debut: '14:30',
                            fin: '19:15',
                        },
                    ],
                },
                {
                    noJour: 3,
                    plagesHoraire: [
                        {
                            debut: '10:30',
                            fin: '13:30',
                        },
                        {
                            debut: '14:30',
                            fin: '19:15',
                        },
                    ],
                },
                {
                    noJour: 4,
                    plagesHoraire: [
                        {
                            debut: '10:30',
                            fin: '13:30',
                        },
                        {
                            debut: '14:30',
                            fin: '19:15',
                        },
                    ],
                },
                {
                    noJour: 5,
                    plagesHoraire: [
                        {
                            debut: '10:30',
                            fin: '13:30',
                        },
                        {
                            debut: '14:30',
                            fin: '19:15',
                        },
                    ],
                },
                {
                    noJour: 6,
                    plagesHoraire: [
                        {
                            debut: '10:30',
                            fin: '13:30',
                        },
                        {
                            debut: '14:30',
                            fin: '19:15',
                        },
                    ],
                },
            ],
            entiteJuridique: {
                typeEntiteReseauDistribution: 'CM',
                siren: '438673568',
            },
            typeEntiteReseauDistribution: 'CM',
            estPetitBackOffice: false,
            proprietesERD: [
                {
                    id: '1',
                    nom: 'petit_back_office',
                    type: 'BOOLEEN',
                    valeurBool: false,
                },
            ],
            seuilsProduits: [
                {
                    gencode: '8806090306419',
                    seuilCnC: 3,
                    seuilEResa: 0,
                },
            ],
            gencodes: ['8806090306419'],
        },
        {
            self: {
                href: '/consultation-boutique?codeEnseigne=400&codePointVente=2357',
            },
            codeEnseigne: '400',
            codePointVente: '2357',
            distanceLocalisation: 2403,
            libelleEnseigneCommerciale: 'BOUYGUES TELECOM',
            nom: 'PARIS RIVOLI',
            adresse: {
                adresseLigne1: '33 RUE DE RIVOLI',
                ville: 'PARIS',
                codePostal: '75004',
                pays: 'FR',
                localisation: {
                    latitude: 48.85753,
                    longitude: 2.3506,
                },
            },
            horairesOuvertureDuJour: {
                plagesHoraire: [
                    {
                        debut: '10:00',
                        fin: '20:00',
                    },
                ],
            },
            activitesBoutique: {
                cncActif: true,
                eresaActif: true,
                webActif: true,
                maxCnC: 65,
                maxEResa: 0,
                maxCnC_sav: 50,
                maxCnC_vente: 15,
            },
            contact: {
                telephone1: '144549481',
                telephone2: '',
                fax: '144549483',
                email: 'ParisRivoli-014K@rcbt.fr',
                employeTelephone1: '0760278660',
                employeTelephone2: '0619104890',
                employeTelephone3: '0660673714',
            },
            responsable: {
                nom: 'Vincent Ho Dinh',
                telephone: '',
            },
            horairesOuvertureHebdomadaire: [
                {
                    noJour: 1,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '20:00',
                        },
                    ],
                },
                {
                    noJour: 2,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '20:00',
                        },
                    ],
                },
                {
                    noJour: 3,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '20:00',
                        },
                    ],
                },
                {
                    noJour: 4,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '20:00',
                        },
                    ],
                },
                {
                    noJour: 5,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '20:00',
                        },
                    ],
                },
                {
                    noJour: 6,
                    plagesHoraire: [
                        {
                            debut: '10:00',
                            fin: '20:00',
                        },
                    ],
                },
            ],
            entiteJuridique: {
                typeEntiteReseauDistribution: 'CM',
                siren: '799174446',
            },
            typeEntiteReseauDistribution: 'CM',
            estPetitBackOffice: false,
            proprietesERD: [
                {
                    id: '1',
                    nom: 'petit_back_office',
                    type: 'BOOLEEN',
                    valeurBool: false,
                },
            ],
            seuilsProduits: [
                {
                    gencode: '8806090306419',
                    seuilCnC: 3,
                    seuilEResa: 0,
                },
            ],
            gencodes: ['8806090306419'],
        },
    ],
};

const RELAIS_COLIS = {
    items: [
        {
            adresse: {
                coordonneesGps: {
                    latitude: '44.828055',
                    longitude: '-0.560677',
                },
                cp: '33800',
                num: '195',
                rue: 'COURS DE LA MARNE',
                ville: 'BORDEAUX',
            },
            distanceLocalisation: 29,
            estUneConsigne: false,
            idPointRelais: '2846R',
            libelle: 'FLORIREVE',
            reseauLivraison: 'CHRONOPOST',
            horairesHabituels: [
                {
                    jourSemaine: 'DIMANCHE',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '16:00',
                            heureFin: '19:00',
                        },
                    ],
                    jourSemaine: 'SAMEDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:45',
                            heureFin: '13:30',
                        },
                        {
                            heureDebut: '16:00',
                            heureFin: '19:30',
                        },
                    ],
                    jourSemaine: 'VENDREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:45',
                            heureFin: '13:30',
                        },
                        {
                            heureDebut: '16:00',
                            heureFin: '19:30',
                        },
                    ],
                    jourSemaine: 'JEUDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:45',
                            heureFin: '13:30',
                        },
                        {
                            heureDebut: '16:00',
                            heureFin: '19:30',
                        },
                    ],
                    jourSemaine: 'MERCREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:45',
                            heureFin: '13:30',
                        },
                        {
                            heureDebut: '16:00',
                            heureFin: '19:30',
                        },
                    ],
                    jourSemaine: 'MARDI',
                },
                {
                    jourSemaine: 'LUNDI',
                },
            ],
        },
        {
            adresse: {
                complementAdr1: 'NIVEAU -1 SORTIE PARKING MINUTE',
                coordonneesGps: {
                    latitude: '44.824901',
                    longitude: '-0.556709',
                },
                cp: '33800',
                num: '37',
                rue: 'RUE CHARLES DOMERCQ',
                ville: 'BORDEAUX',
            },
            distanceLocalisation: 482,
            estUneConsigne: true,
            idPointRelais: '0264X',
            libelle: 'CONSIGNE PICKUP GARE BORDEAUXSTJEAN',
            reseauLivraison: 'CHRONOPOST',
            horairesHabituels: [
                {
                    creneaux: [
                        {
                            heureDebut: '04:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '23:59',
                        },
                    ],
                    jourSemaine: 'DIMANCHE',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '04:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '23:59',
                        },
                    ],
                    jourSemaine: 'SAMEDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '04:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '23:59',
                        },
                    ],
                    jourSemaine: 'VENDREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '04:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '23:59',
                        },
                    ],
                    jourSemaine: 'JEUDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '04:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '23:59',
                        },
                    ],
                    jourSemaine: 'MERCREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '04:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '23:59',
                        },
                    ],
                    jourSemaine: 'MARDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '04:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '23:59',
                        },
                    ],
                    jourSemaine: 'LUNDI',
                },
            ],
        },
        {
            adresse: {
                coordonneesGps: {
                    latitude: '44.8295326',
                    longitude: '-0.5671304',
                },
                cp: '33800',
                num: '93',
                rue: 'COURS DE LA MARNE',
                ville: 'BORDEAUX',
            },
            distanceLocalisation: 540,
            estUneConsigne: false,
            idPointRelais: '3027U',
            libelle: 'LE PALAIS DE LA MODE',
            reseauLivraison: 'CHRONOPOST',
            horairesHabituels: [
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:30',
                            heureFin: '19:00',
                        },
                    ],
                    jourSemaine: 'DIMANCHE',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'SAMEDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'VENDREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'JEUDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'MERCREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'MARDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'LUNDI',
                },
            ],
        },
        {
            adresse: {
                coordonneesGps: {
                    latitude: '44.8338473',
                    longitude: '-0.5656401',
                },
                cp: '33800',
                num: '12',
                rue: 'PLACE CANTELOUP',
                ville: 'BORDEAUX',
            },
            distanceLocalisation: 738,
            estUneConsigne: false,
            idPointRelais: '9242S',
            libelle: 'BOUCHERIE DIMA HALLAL',
            reseauLivraison: 'CHRONOPOST',
            horairesHabituels: [
                {
                    creneaux: [
                        {
                            heureDebut: '08:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'DIMANCHE',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '08:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'SAMEDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '08:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'VENDREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '08:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'JEUDI',
                },
                {
                    jourSemaine: 'MERCREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '08:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'MARDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '08:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'LUNDI',
                },
            ],
        },
        {
            adresse: {
                coordonneesGps: {
                    latitude: '44.8302677',
                    longitude: '-0.5708296',
                },
                cp: '33800',
                num: '23',
                rue: 'COURS DE LA MARNE',
                ville: 'BORDEAUX',
            },
            distanceLocalisation: 843,
            estUneConsigne: false,
            idPointRelais: '8989R',
            libelle: 'CAVE DE LA MARNE',
            reseauLivraison: 'CHRONOPOST',
            horairesHabituels: [
                {
                    jourSemaine: 'DIMANCHE',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:30',
                            heureFin: '13:00',
                        },
                        {
                            heureDebut: '16:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'SAMEDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:30',
                            heureFin: '13:00',
                        },
                        {
                            heureDebut: '16:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'VENDREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:30',
                            heureFin: '13:00',
                        },
                        {
                            heureDebut: '16:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'JEUDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:30',
                            heureFin: '13:00',
                        },
                        {
                            heureDebut: '16:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'MERCREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:30',
                            heureFin: '13:00',
                        },
                        {
                            heureDebut: '16:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'MARDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:30',
                            heureFin: '13:00',
                        },
                        {
                            heureDebut: '16:00',
                            heureFin: '20:00',
                        },
                    ],
                    jourSemaine: 'LUNDI',
                },
            ],
        },
        {
            adresse: {
                complementAdr2: 'A COTE DE LA PHARMACIE',
                coordonneesGps: {
                    latitude: '44.8349998',
                    longitude: '-0.5668799',
                },
                cp: '33000',
                num: '52',
                rue: 'RUE DES FAURES',
                ville: 'BORDEAUX',
            },
            distanceLocalisation: 899,
            estUneConsigne: false,
            idPointRelais: '4569S',
            libelle: 'EPICERIE MOHAMED MAGHNOUJI',
            reseauLivraison: 'CHRONOPOST',
            horairesHabituels: [
                {
                    creneaux: [
                        {
                            heureDebut: '09:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '21:00',
                        },
                    ],
                    jourSemaine: 'DIMANCHE',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '21:00',
                        },
                    ],
                    jourSemaine: 'SAMEDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '21:00',
                        },
                    ],
                    jourSemaine: 'VENDREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '21:00',
                        },
                    ],
                    jourSemaine: 'JEUDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '21:00',
                        },
                    ],
                    jourSemaine: 'MERCREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '21:00',
                        },
                    ],
                    jourSemaine: 'MARDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '09:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '21:00',
                        },
                    ],
                    jourSemaine: 'LUNDI',
                },
            ],
        },
        {
            adresse: {
                coordonneesGps: {
                    latitude: '44.8298605',
                    longitude: '-0.5733177',
                },
                cp: '33000',
                num: '15',
                rue: 'COURS DE L ARGONNE',
                ville: 'BORDEAUX',
            },
            distanceLocalisation: 1026,
            estUneConsigne: false,
            idPointRelais: '0702U',
            libelle: 'CYBER DE LA VICTOIRE',
            reseauLivraison: 'CHRONOPOST',
            horairesHabituels: [
                {
                    creneaux: [
                        {
                            heureDebut: '18:00',
                            heureFin: '19:00',
                        },
                        {
                            heureDebut: '19:00',
                            heureFin: '22:00',
                        },
                    ],
                    jourSemaine: 'DIMANCHE',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '14:00',
                            heureFin: '22:00',
                        },
                    ],
                    jourSemaine: 'SAMEDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '22:00',
                        },
                    ],
                    jourSemaine: 'VENDREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '22:00',
                        },
                    ],
                    jourSemaine: 'JEUDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '22:00',
                        },
                    ],
                    jourSemaine: 'MERCREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '22:00',
                        },
                    ],
                    jourSemaine: 'MARDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '22:00',
                        },
                    ],
                    jourSemaine: 'LUNDI',
                },
            ],
        },
        {
            adresse: {
                coordonneesGps: {
                    latitude: '44.8314551',
                    longitude: '-0.5730073',
                },
                cp: '33000',
                num: '30',
                rue: 'PLACE DE LA VICTOIRE',
                ville: 'BORDEAUX',
            },
            distanceLocalisation: 1047,
            estUneConsigne: false,
            idPointRelais: '8784S',
            libelle: 'KIOSQUE LM PRESSE',
            reseauLivraison: 'CHRONOPOST',
            horairesHabituels: [
                {
                    jourSemaine: 'DIMANCHE',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '08:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '19:00',
                        },
                    ],
                    jourSemaine: 'SAMEDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '08:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '19:00',
                        },
                    ],
                    jourSemaine: 'VENDREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '08:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '19:00',
                        },
                    ],
                    jourSemaine: 'JEUDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '08:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '19:00',
                        },
                    ],
                    jourSemaine: 'MERCREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '08:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '19:00',
                        },
                    ],
                    jourSemaine: 'MARDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '08:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '19:00',
                        },
                    ],
                    jourSemaine: 'LUNDI',
                },
            ],
        },
        {
            adresse: {
                complementAdr1: 'DEVANT LE CROUS',
                coordonneesGps: {
                    latitude: '44.8305532',
                    longitude: '-0.5739915',
                },
                cp: '33000',
                num: '42',
                rue: 'RUE SAUTEYRON',
                ville: 'BORDEAUX',
            },
            distanceLocalisation: 1093,
            estUneConsigne: true,
            idPointRelais: '0297X',
            libelle: 'CONSIGNE PICKUP CROUS VICTOIRE',
            reseauLivraison: 'CHRONOPOST',
            horairesHabituels: [
                {
                    creneaux: [
                        {
                            heureDebut: '00:01',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '23:59',
                        },
                    ],
                    jourSemaine: 'DIMANCHE',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '00:01',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '23:59',
                        },
                    ],
                    jourSemaine: 'SAMEDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '00:01',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '23:59',
                        },
                    ],
                    jourSemaine: 'VENDREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '00:01',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '23:59',
                        },
                    ],
                    jourSemaine: 'JEUDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '00:01',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '23:59',
                        },
                    ],
                    jourSemaine: 'MERCREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '00:01',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '23:59',
                        },
                    ],
                    jourSemaine: 'MARDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '00:01',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '23:59',
                        },
                    ],
                    jourSemaine: 'LUNDI',
                },
            ],
        },
        {
            adresse: {
                coordonneesGps: {
                    latitude: '44.8336681',
                    longitude: '-0.5730865',
                },
                cp: '33000',
                num: '220',
                rue: 'RUE SAINTE CATHERINE',
                ville: 'BORDEAUX',
            },
            distanceLocalisation: 1159,
            estUneConsigne: false,
            idPointRelais: '1705U',
            libelle: 'FOOT LAND',
            reseauLivraison: 'CHRONOPOST',
            horairesHabituels: [
                {
                    jourSemaine: 'DIMANCHE',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '19:00',
                        },
                    ],
                    jourSemaine: 'SAMEDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '19:00',
                        },
                    ],
                    jourSemaine: 'VENDREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '19:00',
                        },
                    ],
                    jourSemaine: 'JEUDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '19:00',
                        },
                    ],
                    jourSemaine: 'MERCREDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '19:00',
                        },
                    ],
                    jourSemaine: 'MARDI',
                },
                {
                    creneaux: [
                        {
                            heureDebut: '10:00',
                            heureFin: '12:00',
                        },
                        {
                            heureDebut: '12:00',
                            heureFin: '19:00',
                        },
                    ],
                    jourSemaine: 'LUNDI',
                },
            ],
        },
    ],
    resultCounts: 10,
};

const MODE_LIVRAISON = {
    adresse: { codePostal: '57570' },
    modesLivraison: [
        {
            gencode: 'CLICK_COLLECT',
            libelle: 'CLICK & COLLECT',
            dateLivraisonEstimee: '2021-03-31T10:25+02:00',
            dateLivraisonEstimeeAuPlusTard: '2021-04-03T10:25+02:00',
            prix: 0,
            heureLimite: '12:25:16.000',
        },
        {
            gencode: 'POINT_RELAIS_EXPRESS',
            libelle: 'POINT RELAIS EXPRESS',
            dateLivraisonEstimee: '2021-04-01T10:25+02:00',
            dateLivraisonEstimeeAuPlusTard: '2021-04-02T10:25+02:00',
            prix: 0,
            heureLimite: '12:00:00.000',
        },
        {
            gencode: 'CHRONOPOST',
            libelle: 'LIVRAISON A DOMICILE EXPRESS',
            dateLivraisonEstimee: '2021-04-01T10:25+02:00',
            dateLivraisonEstimeeAuPlusTard: '2021-04-02T10:25+02:00',
            prix: 9.9,
            heureLimite: '13:00:00.000',
        },
        {
            gencode: 'LIVRAISON_DIRECTE',
            libelle: 'LIVRAISON A DOMICILE',
            dateLivraisonEstimee: '2021-04-02T10:25+02:00',
            dateLivraisonEstimeeAuPlusTard: '2021-04-06T10:25+02:00',
            prix: 5.9,
            heureLimite: '13:00:00.000',
        },
    ],
    _links: { rechercherPointsRelais: { type: 'application/json', href: '/points-relais' } },
};

const MODE_LIVRAISON_WITH_GHOST = { ...MODE_LIVRAISON };
MODE_LIVRAISON_WITH_GHOST.modesLivraison.push({
    gencode: 'doNotExist',
    libelle: 'Fantome',
    dateLivraisonEstimee: '2021-04-01T09:06+02:00',
    dateLivraisonEstimeeAuPlusTard: '2021-04-01T09:06+02:00',
    prix: 0,
    heureLimite: '13:00:00.000',
});

const DELIVERY_MOCKS: StepMock[] = [
    {
        url: '/ventes/click-and-collect',
        mocks: [
            {
                key: 'clicCollect',
                label: 'Clic & Collect defaut',
                data: CLICK_COLLECT,
                default: true,
            },
        ],
    },
    {
        url: '/points-relais',
        mocks: [
            {
                key: 'relais',
                label: 'Points relais defaut',
                data: RELAIS_COLIS,
                default: false,
            },
        ],
    },
    {
        url: '/modes-livraison',
        mocks: [
            {
                key: 'shippingModes',
                label: 'mode de livraison defaut',
                data: MODE_LIVRAISON,
                default: false,
            },
            {
                key: 'noShippingModes',
                label: 'aucun mode de livraison',
                data: { adresse: { codePostal: '59160' }, modesLivraison: [] },
                default: false,
            },
            {
                key: 'shippingsModesWithUnknown',
                label: 'Mode de livraison avec mode livraison inconnu',
                data: MODE_LIVRAISON_WITH_GHOST,
                default: false,
            },
        ],
    },
];

export default DELIVERY_MOCKS;
